module.exports = __webpack_public_path__ + "img/feature-coach.e64240b4.jpg";